module.exports = __webpack_public_path__ + "static/media/Poweredby.af0ab27b.svg";